package org.gymly.api.dto

import kotlinx.serialization.Serializable

@Serializable
data class AsistenteEstadoDto(
    val habilitado: Boolean = false,
    val puedeUsar: Boolean = false,
    val chatLibre: Boolean = false,
)

@Serializable
data class AsistenteEncendidoDto(
    val habilitado: Boolean,
)

@Serializable
data class AsistentePreguntaDto(
    val conversacionId: String? = null,
    val pregunta: String,
    val modo: String,
)

@Serializable
data class AsistenteRapidaDto(
    val conversacionId: String? = null,
    val clave: String,
)

@Serializable
data class AsistenteRespuestaDto(
    val conversacionId: String? = null,
    val texto: String = "",
    val herramientasUsadas: Int = 0,
)

@Serializable
data class AsistenteConversacionDto(
    val id: String,
    val creadaEn: String,
    val primeraPregunta: String,
)

@Serializable
data class AsistenteMensajeDto(
    val rol: String,
    val texto: String,
    val creadoEn: String,
)

@Serializable
data class AsistenteConversacionAuditadaDto(
    val id: String,
    val usuario: String,
    val creadaEn: String,
    val primeraPregunta: String,
)

@Serializable
data class AsistentePreguntaSinRespuestaDto(
    val pregunta: String,
    val veces: Int,
    val ultima: String,
)

@Serializable
data class AsistentePersonalizacionDto(
    val nombre: String = "Asistente",
    val color: String = "#1E5BD8",
    val logoUrl: String? = null,
)

@Serializable
data class AsistenteCatalogoDto(
    val codigo: String,
    val nombre: String,
    val tipo: String,
    val baseUrl: String? = null,
)

@Serializable
data class AsistenteModelosRequestDto(
    val tipo: String,
    val baseUrl: String? = null,
    val clave: String? = null,
    val proveedorId: String? = null,
)

@Serializable
data class AsistenteProveedorDto(
    val id: String,
    val nombre: String,
    val tipo: String = "GEMINI",
    val baseUrl: String? = null,
    val modelo: String,
    val activo: Boolean,
    val tieneClave: Boolean,
    val limiteMensualCents: Long = 0,
    val limiteDiarioTokens: Long = 0,
    val maxTokensSalida: Int = 1024,
    val precioEntradaPorMillon: Long = 0,
    val precioSalidaPorMillon: Long = 0,
    val gastoMesCents: Long = 0,
    val tokensHoy: Long = 0,
)

@Serializable
data class AsistenteAgenteDto(
    val id: String,
    val nombre: String,
    val modo: String,
    val maxPasos: Int,
    val herramientas: List<String> = emptyList(),
    val activo: Boolean,
    val proveedorPrincipalId: String? = null,
    val proveedorRespaldoId: String? = null,
)

@Serializable
data class AsistenteConfiguracionDto(
    val habilitado: Boolean = false,
    val chatLibre: Boolean = false,
    val proveedores: List<AsistenteProveedorDto> = emptyList(),
    val agentes: List<AsistenteAgenteDto> = emptyList(),
    val herramientasDisponibles: List<String> = emptyList(),
    val catalogo: List<AsistenteCatalogoDto> = emptyList(),
)

@Serializable
data class AsistenteDatosProveedorDto(
    val nombre: String,
    val tipo: String,
    val baseUrl: String? = null,
    val modelo: String,
    val activo: Boolean,
    val limiteMensualCents: Long,
    val limiteDiarioTokens: Long,
    val maxTokensSalida: Int,
    val precioEntradaPorMillon: Long,
    val precioSalidaPorMillon: Long,
    val clave: String? = null,
)

@Serializable
data class AsistenteActualizarAgenteDto(
    val activo: Boolean,
    val maxPasos: Int,
    val herramientas: List<String>,
    val proveedorPrincipalId: String? = null,
    val proveedorRespaldoId: String? = null,
)
